import { MutationKey } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { Environment } from '@playq/octopus-common';

import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { SupportContentType, IBeetleId, IBeetleStatus } from '/component/Support/BeetlesLookup/types';

import { methods } from './serviceHandlerRequest';

export const updateStatusBatchMutationKey: MutationKey = ['mutation', 'updateStatus', 'batch'];

export const useUpdateBatchStatus = (
  method: SupportContentType,
  options?: UseMutationOptionsExtended<
    CommonSuccess,
    GenericFailure | Error,
    { ids: IBeetleId[]; status: IBeetleStatus; env: Environment }
  >
) => {
  const request = methods(method);
  return useEitherMutation(({ ids, status, env }) => request.updateBatch(ids, status, env), {
    mutationKey: updateStatusBatchMutationKey.concat(method),
    ...options,
  });
};
